
import './App.css';
import ScrollToTop from './Components/ScrollToTop'; // ⬅️ Add this import
import Header from './Components/Header';
import Home from './Components/Home';
import About from './Components/About';
import Contact from './Components/Contact';
import Login from './Components/Login';
import SignUp from './Components/SignUp';
import MainServices from './Components/MainServices';
import OurTeam from './Components/OurTeam';
import AnandS from './Components/team/AnandS';
import SachinB from './Components/team/SachinB';
import Career from './Components/Career';
import Plans from './Components/Plans';
import Corptrg from './Components/Corptrg';
import Privacypolicy from './Components/Privacypolicy';
import Powerbi from './Components/Powerbi';
import Advexl from './Components/Advexl';
import Gallery from './Components/Gallery';
import AIDrivenSoftware from './Components/services/AIDrivenSoftware';
import AIWebsiteDesignWithSEO from './Components/services/AIWebsiteDesignWithSEO';
import MobileAppDevelopment from './Components/services/MobileAppDevelopment';
import PowerBITraining from './Components/services/PowerBITraining';
import RPASolutions from './Components/services/RPASolutions';
import ExcelDashboardTraining from './Components/services/ExcelDashboardTraining';
import DatabaseManagementSolutions from './Components/services/DatabaseManagementSolutions';
import CorporateTrainingSolutions from './Components/services/CorporateTrainingSolutions';
import DataAnalyticsAIInsights from './Components/services/DataAnalyticsAIInsights';
import CyberSecurityTrainingConsulting from './Components/services/CyberSecurityTrainingConsulting';
import SocialMediaContentCreation from './Components/services/SocialMediaContentCreation';
import DigitalMediaMarketing from './Components/services/DigitalMediaMarketing';
import ITServices from './Components/services/ITServices';
import EcommerceSaaS from './Components/services/EcommerceSaaS';
import JobsPortal from './Components/services/JobsPortal';
import BusinessConsultancyServices from './Components/services/BusinessConsultancyServices';
import DigitalizationProcessAutomation from './Components/services/DigitalizationProcessAutomation';
import TermsOfService from './Components/TermsOfService';
import SocialMediaGallery from './Components/SocialMediaGallery';
import Servicelogined from './Components/Servicelogined';
import Dashboard from './Components/dashboard';
import Footer from './Components/Footer';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ProtectedRoute from './ProtectedRoute'; // ✅ Make sure you have this file
import { AuthProvider } from './context/AuthContext'; // ✅ Import AuthProvider

function App() {
  return (
    <div className="App">
      <AuthProvider> 
        <BrowserRouter>
        <ScrollToTop />
          <Header />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/services' element={<MainServices />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/login' element={<Login />} />
            <Route path='/register' element={<SignUp />} />
            <Route path='/gallery' element={<Gallery />} />
            <Route path='/SocialMediaGallery' element={<SocialMediaGallery />} />
            <Route path='/Career' element={<Career />} />
            <Route path='/OurTeam' element={<OurTeam />} />
            <Route path='/Plans' element={<Plans />} />
            <Route path='/Advexl' element={<Advexl />} />
            <Route path='/Corptrg' element={<Corptrg />} />
            <Route path='/Privacypolicy' element={<Privacypolicy />} />
            <Route path='/TermsOfService' element={<TermsOfService />} />
            <Route path='/team/AnandS' element={<AnandS />} />
            <Route path='/team/SachinB' element={<SachinB />} />
            <Route path='/AIDrivenSoftware' element={<AIDrivenSoftware />} />
            <Route path='/AIWebsiteDesignWithSEO' element={<AIWebsiteDesignWithSEO />} />
            <Route path='/MobileAppDevelopment' element={<MobileAppDevelopment />} />
            <Route path='/RPASolutions' element={<RPASolutions />} />
            <Route path='/PowerBITraining' element={<PowerBITraining />} />
            <Route path='/ExcelDashboardTraining' element={<ExcelDashboardTraining />} />
            <Route path='/DatabaseManagementSolutions' element={<DatabaseManagementSolutions />} />
            <Route path='/CorporateTrainingSolutions' element={<CorporateTrainingSolutions />} />
            <Route path='/DataAnalyticsAIInsights' element={<DataAnalyticsAIInsights />} />
            <Route path='/CyberSecurityTrainingConsulting' element={<CyberSecurityTrainingConsulting />} />
            <Route path='/ITServices' element={<ITServices />} />
            <Route path='/SocialMediaContentCreation' element={<SocialMediaContentCreation />} />
            <Route path='/DigitalMediaMarketing' element={<DigitalMediaMarketing />} />
            <Route path='/EcommerceSaaS' element={<EcommerceSaaS />} />
            <Route path='/JobsPortal' element={<JobsPortal />} />
            <Route path='/DigitalizationProcessAutomation' element={<DigitalizationProcessAutomation />} />
            <Route path='/BusinessConsultancyServices' element={<BusinessConsultancyServices />} />

            {/* 🔒 Protected Routes */}
            <Route
              path='/dashboard'
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path='/Powerbi'
              element={
                <ProtectedRoute>
                  <Powerbi />
                </ProtectedRoute>
              }
            />
            <Route
              path='/Servicelogined'
              element={
                <ProtectedRoute>
                  <Servicelogined />
                </ProtectedRoute>
              }
            /> 
          </Routes>
          <Footer />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
